import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  margin: -10px 40px 0px 0px;\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  align-items: center;\n  margin-top: 10px;\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  width: 235px;\n  height: 140px;\n  margin-bottom: 20px;\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  font-size: 9.52px;\n  line-height: 13px;\n  color: ", ";\n  margin-top: 10px;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  margin-bottom: 10px;\n  color: ", ";\n  @media screen and (max-width: 382px) {\n    margin-bottom: 30px;\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  margin-bottom: 5px;\n  color: ", ";\n  @media screen and (max-width: ", "px) {\n    margin: auto;\n    margin-left: 0px;\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: ", "px) {\n    flex-direction: row;\n    margin-bottom: 5px;\n  }\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (max-width: ", "px) {\n    height: 375px;\n  }\n  height: 255px;\n  background-image: url(", ");\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  background: ", ";\n  max-width: 420px;\n  margin-bottom: -60px;\n  border-radius: 40px;\n  padding: 30px 30px 80px;\n  box-sizing: border-box;\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n    position: fixed;\n    top: auto;\n    bottom: 0;\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  p {\n    /* gets desired effect of 40px + 25px = 65px right padding */\n    padding-right: 25px;\n  }\n  border-radius: 0 0 30px 30px;\n  @media screen and (max-width: ", "px) {\n    border-radius: 0;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  max-width: 420px;\n  border-radius: 30px;\n  padding: 40px;\n  box-sizing: border-box;\n  @media screen and (max-width: ", "px) {\n    bottom: 0px;\n    left: 0px;\n    position: fixed;\n    top: auto;\n    left: 0;\n    right: 0;\n    max-height: 80vh;\n    min-height: 50px;\n    border-radius: 30px 30px 0 0;\n    padding: 30px;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    background-color: ", ";\n    box-shadow: ", ";\n    z-index: 11;\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-grow: 1;\n  padding-top: 10px;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-grow: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  background-color: ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: none;\n  background-color: ", ";\n  border-radius: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  max-width: 420px;\n  width: 100%;\n  padding: 40px;\n  border-radius: 20px;\n  box-sizing: border-box;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  line-height: 30px;\n  margin-right: 10px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  left: 0px;\n  position: fixed;\n  top: auto;\n  left: 0;\n  right: 0;\n  max-height: 80vh;\n  min-height: 50px;\n  border-radius: 30px 30px 0 0;\n  padding: 30px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: 11;\n\n  animation-delay: 350ms;\n  animation-fill-mode: both;\n  animation-duration: 450ms;\n  animation-name: ", ";\n\n  &.closing {\n    animation-name: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  from,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    animation-timing-function: cubic-bezier(0.23, 1.25, 0.46, 1);\n  }\n\n  0% {\n    bottom: 0;\n  }\n\n  to {\n    bottom: -80vh;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  from,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    animation-timing-function: cubic-bezier(0.23, 1.25, 0.46, 1);\n  }\n\n  0% {\n    bottom: -80vh;\n  }\n\n  20% {\n    bottom: -40vh;\n  }\n\n  40% {\n    bottom: -20vh;\n  }\n\n  60% {\n    bottom: 0;\n  }\n\n  80% {\n    bottom: 2.4vh;\n  }\n\n  to {\n    bottom: 0;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: rgba(11, 25, 25, 0.1);\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 30;\n\n  animation-delay: 350ms;\n  animation-fill-mode: both;\n  animation-duration: 1ms;\n  animation-name: ", ";\n\n  &.closing: {\n    animation-name: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { AcornsIcon } from '@acorns/icons';
import { Modal, BaseModal } from '../Modal';
import { Card } from '../Card';
import { Bodytext, Caption, Title, Heading } from '../Typography';
import styled, { css, keyframes, useTheme } from '../utils/styling/styled-components';
import { DRAWER_BANNER, DRAWER } from '../utils/testing/TestIDs';
var fadeIn = keyframes(_templateObject());
var fadeOut = keyframes(_templateObject2());
var Overlay = styled.div(_templateObject3(), css(_templateObject4(), fadeIn), css(_templateObject5(), fadeOut));
var bounceInAnimation = keyframes(_templateObject6());
var slideOutAnimation = keyframes(_templateObject7());
var ResponsiveMenuContainer = styled.div(_templateObject8(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lgMedium;
}, css(_templateObject9(), bounceInAnimation), css(_templateObject10(), slideOutAnimation));
var HeaderTitle = styled(Title)(_templateObject11());
var HeaderSubtext = styled(Bodytext)(_templateObject12(), function (props) {
  return props.theme.colors.stone;
});
var StyledModal = styled(Modal)(_templateObject13());
var ButtonContainer = styled.button(_templateObject14(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.ivory;
});
var ButtonContainerForImages = styled(ButtonContainer)(_templateObject15(), function (props) {
  return props.theme.colors.slate;
});
var Header = styled.header(_templateObject16());
var Content = styled.div(_templateObject17());
var StyledCard = styled(Card)(_templateObject18(), function (props) {
  return props.theme.breakpoints.sm;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.shadows.lgMedium;
});
var DrawerBodyForImages = styled(StyledCard)(_templateObject19(), function (props) {
  return props.theme.breakpoints.sm;
});
export var BannerContainer = styled(Card)(_templateObject20(), function (props) {
  return props.color;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  var _props$mobileBannerMa;

  return (_props$mobileBannerMa = props.mobileBannerMarginBottom) !== null && _props$mobileBannerMa !== void 0 ? _props$mobileBannerMa : '100px';
});
export var BannerImageContainer = styled(BannerContainer)(_templateObject21(), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.imagePath;
});
export var BannerContent = styled.div(_templateObject22(), function (props) {
  return props.theme.breakpoints.sm;
});
export var BannerHeader = styled(Heading)(_templateObject23(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.breakpoints.sm;
});
export var BannerBody = styled(Bodytext)(_templateObject24(), function (props) {
  return props.theme.colors.white;
});
export var BannerDisclaimer = styled(Caption)(_templateObject25(), function (props) {
  return props.theme.colors.stoneLight;
});
export var IconContainer = styled.div(_templateObject26());
export var HeaderImage = styled.img(_templateObject27());
export var HeaderWithImage = styled(Header)(_templateObject28());
export var ButtonContainerForHeaderImage = styled(ButtonContainer)(_templateObject29());
export var Drawer = function Drawer(_ref6) {
  var isOpen = _ref6.isOpen,
      _ref6$onClose = _ref6.onClose,
      onClose = _ref6$onClose === void 0 ? function () {} : _ref6$onClose,
      title = _ref6.title,
      subtext = _ref6.subtext,
      children = _ref6.children,
      hasBanner = _ref6.hasBanner,
      imagePath = _ref6.imagePath,
      _ref6$bannerTestId = _ref6.bannerTestId,
      bannerTestId = _ref6$bannerTestId === void 0 ? DRAWER_BANNER : _ref6$bannerTestId,
      bannerColor = _ref6.bannerColor,
      bannerDisclaimer = _ref6.bannerDisclaimer,
      bannerHeader = _ref6.bannerHeader,
      bannerMessage = _ref6.bannerMessage,
      bannerIcon = _ref6.bannerIcon,
      mobileBannerMarginBottom = _ref6.mobileBannerMarginBottom,
      className = _ref6.className,
      _ref6$showClose = _ref6.showClose,
      showClose = _ref6$showClose === void 0 ? true : _ref6$showClose,
      headerImagePath = _ref6.headerImagePath;
  var theme = useTheme();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isClosing = _useState2[0],
      setIsClosing = _useState2[1];

  var content = /*#__PURE__*/React.createElement("div", {
    "data-testid": DRAWER
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(HeaderTitle, null, title)), /*#__PURE__*/React.createElement("div", null, subtext && /*#__PURE__*/React.createElement(HeaderSubtext, null, subtext))), showClose && /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: function onClick(e) {
      e.stopPropagation();
      setIsClosing(true);

      if (window.innerWidth < theme.breakpoints.sm) {
        setTimeout(function () {
          onClose();
          setIsClosing(false);
        }, 800);
      } else {
        onClose();
        setIsClosing(false);
      }
    }
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIcon12Px,
    width: 12
  }))), /*#__PURE__*/React.createElement(Content, null, children));
  var contentWithHeaderImage = /*#__PURE__*/React.createElement("div", {
    "data-testid": DRAWER
  }, /*#__PURE__*/React.createElement(HeaderWithImage, null, /*#__PURE__*/React.createElement(HeaderImage, {
    src: headerImagePath
  }), showClose && /*#__PURE__*/React.createElement(ButtonContainerForHeaderImage, {
    onClick: function onClick(e) {
      e.stopPropagation();
      setIsClosing(true);

      if (window.innerWidth < theme.breakpoints.sm) {
        setTimeout(function () {
          onClose();
          setIsClosing(false);
        }, 800);
      } else {
        onClose();
        setIsClosing(false);
      }
    }
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIcon12Px,
    width: 12
  })), title && /*#__PURE__*/React.createElement(HeaderTitle, null, title), subtext && /*#__PURE__*/React.createElement(HeaderSubtext, null, subtext)), /*#__PURE__*/React.createElement(Content, null, children));
  var BannerAndContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BannerContainer, {
    color: bannerColor !== null && bannerColor !== void 0 ? bannerColor : theme.colors.slate,
    mobileBannerMarginBottom: mobileBannerMarginBottom,
    "data-testid": bannerTestId
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  }, bannerIcon && /*#__PURE__*/React.createElement(IconContainer, null, bannerIcon), /*#__PURE__*/React.createElement(BannerContent, null, bannerHeader && /*#__PURE__*/React.createElement(BannerHeader, null, bannerHeader), bannerMessage && /*#__PURE__*/React.createElement(BannerBody, null, bannerMessage, bannerDisclaimer && /*#__PURE__*/React.createElement(BannerDisclaimer, null, bannerDisclaimer)))), /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(max-width: ".concat(theme.breakpoints.sm, "px)")
  }, /*#__PURE__*/React.createElement(BannerContent, null, bannerIcon && /*#__PURE__*/React.createElement(IconContainer, null, bannerIcon), bannerHeader && /*#__PURE__*/React.createElement(BannerHeader, null, bannerHeader)), bannerMessage && /*#__PURE__*/React.createElement(BannerBody, null, bannerMessage, bannerDisclaimer && /*#__PURE__*/React.createElement(BannerDisclaimer, null, bannerDisclaimer)))), /*#__PURE__*/React.createElement(StyledCard, {
    "data-testid": DRAWER
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(HeaderTitle, null, title), subtext && /*#__PURE__*/React.createElement(HeaderSubtext, null, subtext)), /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose();
    }
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIcon12Px,
    width: 12
  }))), /*#__PURE__*/React.createElement(Content, null, children)));
  var BannerAndImageModal = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BannerImageContainer, {
    mobileBannerMarginBottom: mobileBannerMarginBottom,
    "data-testid": bannerTestId,
    imagePath: imagePath
  }, /*#__PURE__*/React.createElement(ButtonContainerForImages, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose();
    }
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIconWhite,
    width: 12
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  }, bannerIcon && /*#__PURE__*/React.createElement(IconContainer, null, bannerIcon), /*#__PURE__*/React.createElement(BannerContent, null, bannerHeader && /*#__PURE__*/React.createElement(BannerHeader, null, bannerHeader), bannerMessage && /*#__PURE__*/React.createElement(BannerBody, null, bannerMessage))), /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(max-width: ".concat(theme.breakpoints.sm, "px)")
  }, /*#__PURE__*/React.createElement(BannerContent, null, bannerIcon && /*#__PURE__*/React.createElement(IconContainer, null, bannerIcon), bannerHeader && /*#__PURE__*/React.createElement(BannerHeader, null, bannerHeader)), bannerMessage && /*#__PURE__*/React.createElement(BannerBody, null, bannerMessage))), /*#__PURE__*/React.createElement(DrawerBodyForImages, {
    "data-testid": DRAWER
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(HeaderTitle, null, title), subtext && /*#__PURE__*/React.createElement(HeaderSubtext, null, subtext))), /*#__PURE__*/React.createElement(Content, null, children)));

  var useBannerOrImage = function useBannerOrImage(hasBanner) {
    if (hasBanner) {
      return BannerAndContent;
    } else {
      return BannerAndImageModal;
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  }, hasBanner || imagePath ? /*#__PURE__*/React.createElement(BaseModal, {
    isOpen: isOpen,
    onRequestClose: onClose,
    className: className
  }, useBannerOrImage(hasBanner)) : /*#__PURE__*/React.createElement(StyledModal, {
    isOpen: isOpen,
    onRequestClose: onClose,
    className: className
  }, headerImagePath ? contentWithHeaderImage : content)), /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(max-width: ".concat(theme.breakpoints.sm, "px)")
  }, isOpen && /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClose,
    className: "".concat(className, " ").concat(isClosing ? 'closing' : '')
  }, hasBanner || imagePath ? /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, useBannerOrImage(hasBanner)) : /*#__PURE__*/React.createElement(ResponsiveMenuContainer, {
    className: isClosing ? 'closing' : '',
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, headerImagePath ? contentWithHeaderImage : content))));
};